import React from 'react';
import { CardCustomPaymentSection, CardInputCustomAmount, CoCheckboxContainer, CustomAmountSubtitle, CustomAmountTitle } from '../../../../pages/EntryCO/EntryCOStyledComponents';
import { colors } from '../../../../styles/Colors';
import { Label, TextBold, TextMedium } from '../../../../styles/GlobalStyledComponents';
import { CardCheckbox, CardColumn, CardInfoSection } from '../../../CardInputs/CardsStyledComponents';
import CustomPaymentSection from './Detail/AmountCard';
import { DebtResponse } from '../../../../interfaces/Debt';


interface CustomPaymentCardProps {
    isSelectedAmount: boolean;
    onSelectInputAmount: () => void;
    quantity: string;
    handleAmountInput: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
    handleOnWheel: (e: React.WheelEvent<HTMLInputElement>) => void;
    amountNotValid: boolean;
    debtResult: DebtResponse | undefined;
    totalDebtAmount: number;
    lastPayment?: number;
    isPaymentPlan?: boolean;
}

const CustomPaymentCard: React.FC<CustomPaymentCardProps> = ({
    isSelectedAmount,
    onSelectInputAmount,
    quantity,
    handleAmountInput,
    handleKeyDown,
    handleOnWheel,
    amountNotValid,
    debtResult,
    totalDebtAmount,
    lastPayment,
    isPaymentPlan
}) => {
    return (
        <CardInputCustomAmount
            onClick={onSelectInputAmount}
            selected={isSelectedAmount}
            borderColor={colors.red7}
            cardPadding="24px"
            id="co-custom-payment-input"
        >
            <CardCustomPaymentSection
                $isSelected={isSelectedAmount}
                id="co-custom-payment-section"
            >
                <CoCheckboxContainer
                    onClick={onSelectInputAmount}
                    id="co-custom-payment-checkbox-container"
                >
                    <CardCheckbox
                        type="radio"
                        checked={isSelectedAmount}
                        readOnly
                        id="co-custom-payment-select-radio-btn-checkbox"
                        name="custom-payment-checkbox"
                    />
                    <Label htmlFor="co-custom-payment-select-radio-btn-checkbox"></Label>
                </CoCheckboxContainer>
                <CardInfoSection id="co-custom-payment-card-section">
                    <CardColumn id="co-custom-payment-card-column">
                        <CustomAmountTitle id="co-custom-payment-card-title">
                            <TextBold fontSize={16} lineHeight={22}>
                                Reduce tu deuda
                            </TextBold>
                        </CustomAmountTitle>
                        <CustomAmountSubtitle>
                            <TextMedium fontSize={14} color={'gray6'} lineHeight={20}>
                                Indica la cantidad que quieras pagar
                            </TextMedium>
                        </CustomAmountSubtitle>
                    </CardColumn>
                </CardInfoSection>
            </CardCustomPaymentSection>
            {isSelectedAmount && (
                <CustomPaymentSection
                    quantity={quantity}
                    handleAmountInput={handleAmountInput}
                    handleKeyDown={handleKeyDown}
                    handleOnWheel={handleOnWheel}
                    amountNotValid={amountNotValid}
                    debtResult={debtResult}
                    totalDebtAmount={totalDebtAmount}
                    lastPayment={lastPayment}
                    isPaymentPlan={isPaymentPlan}
                />
            )}
        </CardInputCustomAmount>
    );
};

export default CustomPaymentCard;